module.exports = __webpack_public_path__ + "img/mbanner2_camera.c440a049.png";